// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { FaPlay, FaDownload, FaEye, FaTrash } from "react-icons/fa";
// import { FaImage } from "react-icons/fa6";
// import "./ViewImages.css";
// import { useParams } from "react-router-dom";
// import Loader from "../../../../../Loader/Loader";
// import { toast } from "react-toastify";

// import {getImagesUsingKeysAPI,getPhotoskeysbyidAPI, deleteSingleImage ,downloadSelectedImages, downloadSingleImage ,downloadFullZip,deleteSelectedImages} from "../../../../../utils/APIs/UploadGalleryApis";

// const LIMIT = 2;

// const ViewImages = () => {

//   const { bookingId, photographerId, clientId } = useParams();

//   const [selectedItems, setSelectedItems] = useState([]);
//   const [galleryData, setGalleryData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [zipLoading, setZipLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);

//   const loaderRef = useRef(null);
//   const isFetchingRef = useRef(false);

//   /* ===============================
//         FETCH GALLERY
//   =============================== */

//   const fetchGallery = useCallback(async (currentPage) => {

//     if (isFetchingRef.current) return;
//     isFetchingRef.current = true;

//     try {

//       setLoading(true);

//       const response = await getPhotoskeysbyidAPI(
//         currentPage,
//         LIMIT,
//         bookingId,
//         photographerId
//       );

//       if (response?.data?.success) {

//         const keys = response?.data?.data || [];

//         const images = await Promise.all(
//           keys
//             .filter((item) => item?.key)
//             .map(async (item) => {
//               const url = await getImagesUsingKeysAPI(bookingId, item.key);
//               return { id: item._id, key: item.key, url };
//             })
//         );

//         setGalleryData((prev) =>
//           currentPage === 1 ? images : [...prev, ...images]
//         );

//         setHasMore(keys.length >= LIMIT);
//       }

//     } catch (error) {
//       console.error("Gallery API Error:", error);
//     } finally {
//       setLoading(false);
//       isFetchingRef.current = false;
//     }

//   }, [bookingId, photographerId]);

//   /* ===============================
//       DELETE SINGLE IMAGE
//   =============================== */

//   const deleteFile = async (key) => {

//     try {

//       const payload = {
//         key: [key],
//         bookingId: bookingId
//       };

//       await deleteSingleImage(payload);

//       setGalleryData((prev) =>
//         prev.filter((item) => item.key !== key)
//       );

//     } catch (error) {
//       console.error("Delete failed", error);
//     }
//   };

//   /* ===============================
//       DELETE SELECTED IMAGES
//   =============================== */

//   const deleteSelected = async () => {

//     try {

//       const selectedKeys = galleryData
//         .filter((item) => selectedItems.includes(item.url))
//         .map((item) => item.key);

//       const payload = {
//         key: selectedKeys,
//         bookingId: bookingId
//       };

//       await deleteSelectedImages(payload);

//       setGalleryData((prev) =>
//         prev.filter((item) => !selectedKeys.includes(item.key))
//       );

//       setSelectedItems([]);

//     } catch (error) {
//       console.error("Delete selected failed", error);
//     }
//   };

//   /* ===============================
//       DOWNLOAD FULL ZIP
//   =============================== */

//   const handleDownloadZip = async () => {

//     try {

//       setZipLoading(true);

//       const payload = {
//         bookingid: bookingId,
//         clientId: clientId,
//         photographerId: photographerId
//       };

//       const response = await downloadFullZip(payload);

//       const blob = new Blob([response.data], { type: "application/zip" });
//       const url = window.URL.createObjectURL(blob);

//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `booking-${bookingId}-files.zip`;

//       document.body.appendChild(a);
//       a.click();

//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);

//     } catch (error) {
//       console.error("Zip download failed", error);
//     } finally {
//       setZipLoading(false);
//     }
//   };

//   /* ===============================
//       INITIAL LOAD
//   =============================== */

//   useEffect(() => {

//     if (!photographerId) {
//       setGalleryData([]);
//       setSelectedItems([]);
//       setHasMore(false);
//       setPage(1);
//       isFetchingRef.current = false;
//       return;
//     }

//     setGalleryData([]);
//     setSelectedItems([]);
//     setHasMore(true);
//     isFetchingRef.current = false;
//     setPage(1);

//     fetchGallery(1);

//   }, [bookingId, photographerId]);

//   useEffect(() => {

//     if (page === 1) return;
//     if (!photographerId) return;

//     fetchGallery(page);

//   }, [page]);

//   /* ===============================
//       INFINITE SCROLL
//   =============================== */

//   useEffect(() => {

//     const observer = new IntersectionObserver(
//       (entries) => {

//         if (
//           entries[0].isIntersecting &&
//           hasMore &&
//           !loading &&
//           !isFetchingRef.current
//         ) {
//           setPage((prev) => prev + 1);
//         }

//       },
//       { threshold: 1 }
//     );

//     if (loaderRef.current) observer.observe(loaderRef.current);

//     return () => observer.disconnect();

//   }, [hasMore, loading]);

//   /* ===============================
//       IMAGE ACTIONS
//   =============================== */

//   const toggleSelect = (url) => {
//     setSelectedItems((prev) =>
//       prev.includes(url)
//         ? prev.filter((item) => item !== url)
//         : [...prev, url]
//     );
//   };

//   const openPreview = (url) => window.open(url, "_blank");

//   const downloadFile = async (key) => {

//     try {

//       setZipLoading(true);

//       const payload = {
//         key: key,
//         bookingId: bookingId
//       };

//       const response = await downloadSingleImage(payload);

//       const blob = new Blob([response.data]);
//       const url = window.URL.createObjectURL(blob);

//       const a = document.createElement("a");
//       a.href = url;

//       const fileName = key.split("/").pop() || "gallery-file";
//       a.download = fileName;

//       document.body.appendChild(a);
//       a.click();

//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);

//     } catch (error) {
//       console.error("Download failed", error);
//     } finally {
//       setZipLoading(false);
//     }
//   };

//   const downloadSelected = async () => {

//     try {

//       setZipLoading(true);

//       const selectedKeys = galleryData
//         .filter((item) => selectedItems.includes(item.url))
//         .map((item) => item.key);

//       const payload = {
//         bookingid: bookingId,
//         keys: selectedKeys
//       };

//       const response = await downloadSelectedImages(payload);

//       const blob = new Blob([response.data], { type: "application/zip" });
//       const url = window.URL.createObjectURL(blob);

//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `selected-files-${bookingId}.zip`;

//       document.body.appendChild(a);
//       a.click();

//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);

//     } catch (error) {
//       console.error("Download selected failed", error);
//     } finally {
//       setZipLoading(false);
//     }
//   };

//   const isVideoKey = (key) =>
//     key?.includes(".mp4") ||
//     key?.includes(".mov") ||
//     key?.includes(".webm");

//   /* ===============================
//       GALLERY ITEM
//   =============================== */

//   const GalleryItem = ({ src, isVideo, fileKey }) => (

//     <div
//       className={`gallery-box video-box ${
//         selectedItems.includes(src) ? "selected" : ""
//       }`}
//     >

//       {isVideo ? (
//         <video src={src} controls className="gallery-video" />
//       ) : (
//         <img
//           src={src}
//           alt="gallery"
//           onClick={() => openPreview(src)}
//           loading="lazy"
//         />
//       )}

//       {isVideo && (
//         <div className="play-overlay">
//           <FaPlay className="play-icon" />
//         </div>
//       )}

//       <div className="gallery-hover">

//         <div className="gallery-actions-hover">

//           <button
//             className="gallery-hover-btn"
//             onClick={(e) => {
//               e.stopPropagation();
//               downloadFile(fileKey);
//             }}
//           >
//             <FaDownload />
//           </button>

//           <button
//             className="gallery-hover-btn"
//             onClick={(e) => {
//               e.stopPropagation();
//               deleteFile(fileKey);
//             }}
//           >
//             <FaTrash />
//           </button>

//           <button
//             className="gallery-hover-btn"
//             onClick={(e) => {
//               e.stopPropagation();
//               openPreview(src);
//             }}
//           >
//             <FaEye />
//           </button>

//         </div>

//         <div className="gallery-checkbox">
//           <input
//             type="checkbox"
//             checked={selectedItems.includes(src)}
//             onChange={() => toggleSelect(src)}
//             onClick={(e) => e.stopPropagation()}
//           />
//         </div>

//       </div>

//     </div>
//   );

//   /* ===============================
//       BUILD GRID
//   =============================== */

//   const buildRows = () => {

//     const rows = [];
//     let i = 0;

//     if (galleryData.length > 0) {

//       const rowItems = galleryData.slice(0, 2);

//       rows.push(
//         <div className="row gallery-row-gap" key="row-0">
//           {rowItems.map((item) => (
//             <div className="col-md-6 col-12" key={item.id}>
//               <GalleryItem
//                 src={item.url}
//                 isVideo={isVideoKey(item.key)}
//                 fileKey={item.key}
//               />
//             </div>
//           ))}
//         </div>
//       );

//       i = 2;
//     }

//     let rowIndex = 1;

//     while (i < galleryData.length) {

//       const group = galleryData.slice(i, i + 9);

//       const col1 = group.slice(0, 3);
//       const col2 = group.slice(3, 6);
//       const col3 = group.slice(6, 9);

//       rows.push(
//         <div className="row gallery-row-gap" key={`row-${rowIndex}`}>
//           {[col1, col2, col3].map((col, colIdx) =>
//             col.length > 0 ? (
//               <div className="col-md-4 col-12" key={colIdx}>
//                 <div className="gallery-col">
//                   {col.map((item) => (
//                     <GalleryItem
//                       key={item.id}
//                       src={item.url}
//                       isVideo={isVideoKey(item.key)}
//                       fileKey={item.key}
//                     />
//                   ))}
//                 </div>
//               </div>
//             ) : null
//           )}
//         </div>
//       );

//       i += 9;
//       rowIndex++;

//     }

//     return rows;
//   };

//   /* ===============================
//       COMING SOON
//   =============================== */

//   if (!photographerId) {

//     return (
//       <div className="container gallery-container">
//         <div className="gallery-coming-soon">
//           <FaImage />
//           <h3>Gallery Coming Soon</h3>
//           <p>
//             Photos will appear here once a photographer is assigned to this booking.
//           </p>
//         </div>
//       </div>
//     );

//   }

//   return (

//     <div className="container gallery-container">

// {(loading || zipLoading) && <Loader />}

//       <div className="gallery-header">

//         <div className="gallery-left">

//           <div className="gallery-pending">7 Days Pending...</div>

//           {selectedItems.length > 0 && (
//             <>
//               <button
//                 className="download-selected-btn"
//                 onClick={downloadSelected}
//               >
//                 Download Selected ({selectedItems.length})
//               </button>

//               <button
//                 className="delete-selected-btn"
//                 onClick={deleteSelected}
//               >
//                 Delete Selected ({selectedItems.length})
//               </button>
//             </>
//           )}

//         </div>

//         <div className="gallery-actions">

//           <button className="gallery-btn outline">
//             Store to Cloud
//           </button>

//           <button
//             className="gallery-btn"
//             onClick={handleDownloadZip}
//             disabled={zipLoading}
//           >
//             {zipLoading ? "Preparing..." : "Download Zip"}
//           </button>

//         </div>

//       </div>

//       {buildRows()}

//       {hasMore && (
//         <div ref={loaderRef} style={{ textAlign: "center", padding: 20 }}>
//           {loading && <Loader />}
//         </div>
//       )}

//     </div>

//   );
// };

// export default ViewImages;



import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaPlay, FaDownload, FaEye, FaTrash } from "react-icons/fa";
import { FaImage } from "react-icons/fa6";
import "./ViewImages.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  // getImagesUsingKeysAPI,
  // getPhotoskeysbyidAPI,
  deleteSingleImage,
  deleteSelectedImages,
  getAllGalleryImages,
  getGalleryZipLink,
  downloadGalleryZipFromCdn,
} from "../../../../../utils/APIs/UploadGalleryApis";
import { getBookingByIdAPI } from "../../../../../utils/APIs/bookingsApis";
import { getAccessToken } from "../../../../../utils/APIs/commonHeadApiLogic";
import {
  appendLightcasePoolLinks,
  bindLightcaseLinks,
  clearLightcasePool,
  destroyLightcaseBindings,
  getVideoPlaybackUrl,
  isVideoMediaKey,
  openLightcaseItem,
} from "../lightcaseGallery";

const LIMIT = 33;

const loadedImagesCache = new Set();

const VirtualGalleryItem = ({ children, isVideo, id, src }) => {
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (hasBeenVisible) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasBeenVisible(true);
        }
      },
      {
        rootMargin: "1200px 0px 1200px 0px",
        threshold: 0.01,
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasBeenVisible]);

  const placeholderStyle = { 
    aspectRatio: "16/10", 
    width: "100%", 
    background: "#eee", 
    borderRadius: "4px" 
  };

  const isAlreadyCached = src && loadedImagesCache.has(src);
  const placeholderClass = `gallery-placeholder-box ${isAlreadyCached ? "" : "loading-skeleton"}`;

  return (
    <div ref={containerRef} className="virtual-gallery-item-wrapper">
      {hasBeenVisible ? (
        children
      ) : (
        <div style={placeholderStyle} className={placeholderClass} />
      )}
    </div>
  );
};

const isEditingBooking = (booking) => {
  if (!booking) return false;
  return (
    booking.serviceCategory === "editing" ||
    booking.eventType?.toLowerCase?.().includes("editing") ||
    booking.service_id?.serviceName?.toLowerCase?.().includes("editing")
  );
};

const hasValidRoutePhotographer = (id) =>
  Boolean(id && id !== "null" && id !== "undefined");

const hasPhotographerOnFile = (item) => {
  const pid = item?.photographerId;
  if (pid == null || pid === false) return false;
  if (typeof pid === "object") return Boolean(pid._id || pid.id);
  const str = String(pid).trim().toLowerCase();
  return str !== "" && str !== "null" && str !== "undefined";
};

const filterByMediaSource = (items, activeCategory) => {
  if (activeCategory === "User Media") {
    return items.filter((item) => !hasPhotographerOnFile(item));
  }
  if (activeCategory === "Photographer Media") {
    return items.filter((item) => hasPhotographerOnFile(item));
  }
  return items;
};

class MediaLoadQueue {
  constructor(concurrency = 4) {
    this.concurrency = concurrency;
    this.running = 0;
    this.queue = [];
  }

  register(onStart) {
    const item = { onStart };
    this.queue.push(item);
    this.next();
    return () => {
      this.queue = this.queue.filter((q) => q !== item);
    };
  }

  next() {
    if (this.running >= this.concurrency || this.queue.length === 0) return;

    this.running++;
    const item = this.queue.shift();

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      this.running--;
      this.next();
    };

    item.onStart(finish);
    setTimeout(finish, 2500); // 2.5s safety timeout
  }
}

const mediaLoadQueue = new MediaLoadQueue(4);

const GalleryItem = React.memo(({
  src,
  isVideo,
  fileKey,
  id,
  isSelected,
  onOpenInLightcase,
  onDownloadFile,
  onDeleteFile,
  onToggleSelect
}) => {
  const [shouldLoad, setShouldLoad] = useState(() => loadedImagesCache.has(src));
  const [isLoaded, setIsLoaded] = useState(() => loadedImagesCache.has(src));
  const mediaRef = useRef(null);
  const finishLoadRef = useRef(null);

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
    loadedImagesCache.add(src);
    if (finishLoadRef.current) {
      finishLoadRef.current();
      finishLoadRef.current = null;
    }
  }, [src]);

  const handleError = useCallback(() => {
    if (finishLoadRef.current) {
      finishLoadRef.current();
      finishLoadRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (shouldLoad) return;

    const unregister = mediaLoadQueue.register((finish) => {
      finishLoadRef.current = finish;
      setShouldLoad(true);
    });

    return () => {
      unregister();
      if (finishLoadRef.current) {
        finishLoadRef.current();
        finishLoadRef.current = null;
      }
    };
  }, [src, shouldLoad]);

  useEffect(() => {
    if (!shouldLoad) return;
    const el = mediaRef.current;
    if (!el) return;

    if (isVideo) {
      if (el.readyState >= 1) {
        handleLoad();
      }
    } else {
      if (el.complete) {
        handleLoad();
      }
    }
  }, [isVideo, handleLoad, shouldLoad]);

  return (
    <div
      className={`gallery-box video-box ${isSelected ? "selected" : ""} ${!isLoaded ? "loading-skeleton" : ""}`}
    >
      {shouldLoad ? (
        isVideo ? (
          <video
            ref={mediaRef}
            src={src}
            className="gallery-video"
            muted
            playsInline
            preload="metadata"
            onLoadedMetadata={handleLoad}
            onError={handleError}
            style={{ visibility: isLoaded ? "visible" : "hidden" }}
            onClick={() => onOpenInLightcase(id)}
          />
        ) : (
          <img
            ref={mediaRef}
            src={src}
            alt="gallery"
            decoding="async"
            onLoad={handleLoad}
            onError={handleError}
            style={{ visibility: isLoaded ? "visible" : "hidden" }}
            onClick={() => onOpenInLightcase(id)}
          />
        )
      ) : (
        <div style={{ width: "100%", height: "100%" }} onClick={() => onOpenInLightcase(id)} />
      )}

      {isVideo && shouldLoad && isLoaded && (
        <div className="play-overlay" onClick={() => onOpenInLightcase(id)}>
          <div className="play-icon">
            <FaPlay className="play-triangle" />
          </div>
        </div>
      )}

      <div
        className="gallery-hover"
        onClick={(e) => {
          if (!e.target.closest("button") && !e.target.closest("input")) {
            onOpenInLightcase(id);
          }
        }}
      >
        <div className="gallery-actions-hover">
          <button
            className="gallery-hover-btn"
            onClick={(e) => {
              e.stopPropagation();
              onDownloadFile(fileKey);
            }}
          >
            <FaDownload />
          </button>

          <button
            className="gallery-hover-btn"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteFile(fileKey);
            }}
          >
            <FaTrash />
          </button>

          <button
            className="gallery-hover-btn"
            onClick={(e) => {
              e.stopPropagation();
              onOpenInLightcase(id);
            }}
          >
            <FaEye />
          </button>
        </div>

        <div className="gallery-checkbox">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => onToggleSelect(id)}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      </div>
    </div>
  );
});

const ViewImages = () => {

  const { bookingId, photographerId } = useParams();

  const [selectedItems, setSelectedItems] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPrefetching, setIsPrefetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loaderRef = useRef(null);
  const isFetchingRef = useRef(false);
  const lightcasePoolRef = useRef(null);
  const lightcasePoolSizeRef = useRef(0);
  const pageRef = useRef(1);
  const hasMoreRef = useRef(true);
  const prefetchActiveRef = useRef(false);
  const prefetchStartedRef = useRef(false);
  const loadedPagesRef = useRef(new Set());
  const navigate = useNavigate();

  const [bookingData, setBookingData] = useState(null);
  const [activeCategory, setActiveCategory] = useState("Standard");
  const isEditing = isEditingBooking(bookingData);

  // Determine available categories based on booking data
  const availableCategories = (() => {
    if (isEditing) return ["User Media", "Photographer Media"];
    return [];
  })();

  useEffect(() => {
    if (availableCategories.length > 0) {
      if (isEditing && availableCategories.includes("Photographer Media") && activeCategory === "Standard") {
        setActiveCategory("Photographer Media");
      } else if (!availableCategories.includes(activeCategory)) {
        setActiveCategory(availableCategories[0]);
      }
    }
  }, [availableCategories, activeCategory, isEditing]);

  /* ===============================
        FETCH BOOKING DATA
  =============================== */
  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const res = await getBookingByIdAPI(bookingId);
        if (res?.data?.success) {
          setBookingData(res.data.data);
        }
      } catch (error) {
        console.error("Fetch booking error", error);
      }
    };
    if (bookingId) fetchBooking();
  }, [bookingId]);

  /* ===============================
        FETCH GALLERY
  =============================== */

  const lightcaseGroup = `booking-gallery-${bookingId}-${activeCategory}`;

  const fetchGallery = useCallback(async (currentPage, { silent = false } = {}) => {
    if (!bookingData) return null;
    if (!isEditing && !hasValidRoutePhotographer(photographerId)) return null;
    if (isFetchingRef.current) return null;
    if (loadedPagesRef.current.has(currentPage)) {
      return { hasMore: hasMoreRef.current, count: 0, cached: true };
    }
    isFetchingRef.current = true;

    try {
      if (!silent) {
        setLoading(true);
      }

      const sourceParam =
        isEditing && activeCategory === "Photographer Media"
          ? "photographer"
          : isEditing && activeCategory === "User Media"
            ? "user"
            : "";

      const response = await getAllGalleryImages(
        currentPage,
        LIMIT,
        bookingId,
        "", // Passing empty string to bypass strict category matching for editing/standard mismatch
        sourceParam,
        photographerId || ""
      );

      if (response?.data?.success) {

        const files = response?.data?.data || [];

        const images = files.map((item, index) => ({
          id: item._id || `${currentPage}-${index}`,
          key: item.key,
          url: item.imageUrl,
          photographerId: item.photographerId
        }));
        setGalleryData((prev) =>
          currentPage === 1 ? images : [...prev, ...images]
        );

        const nextHasMore = Boolean(response?.data?.pagination?.hasMore);
        loadedPagesRef.current.add(currentPage);
        setHasMore(nextHasMore);
        hasMoreRef.current = nextHasMore;
        pageRef.current = currentPage;
        setPage(currentPage);

        return { hasMore: nextHasMore, count: images.length };

      } else {

        if (!silent) {
          toast.error(response?.data?.message || "Failed to load gallery");
        }

      }

    } catch (error) {

      console.error("Gallery API Error:", error);

      if (!silent) {
        toast.error(
          error?.response?.data?.message ||
          error?.message ||
          "Gallery loading failed"
        );
      }

    } finally {

      if (!silent) {
        setLoading(false);
      }
      isFetchingRef.current = false;

    }

    return null;

  }, [bookingId, bookingData, activeCategory, isEditing, photographerId]);

  /* =================================== 
  HANDLE SELECT ALL
   =================================== */

  const visibleGalleryData = isEditing
    ? filterByMediaSource(galleryData, activeCategory)
    : galleryData;

  const handleSelectAll = () => {
    if (selectedItems.length === visibleGalleryData.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(visibleGalleryData.map((item) => item.id));
    }
  };

  /* ===============================
      DELETE SINGLE IMAGE
  =============================== */

  const deleteFile = useCallback(async (key) => {

    try {

      setLoading(true);

      const payload = {
        key: [key],
        bookingId: bookingId
      };

      const response = await deleteSingleImage(payload);

      setGalleryData((prev) =>
        prev.filter((item) => item.key !== key)
      );

      toast.success(response?.data?.message || "Image deleted successfully");

    } catch (error) {

      console.error("Delete failed", error);

      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Delete failed"
      );

    } finally {

      setLoading(false);

    }

  }, [bookingId]);

  /* ===============================
      DELETE SELECTED IMAGES
  =============================== */

  const deleteSelected = async () => {

    try {

      setLoading(true);

      const selectedKeys = galleryData
        .filter((item) => selectedItems.includes(item.id))
        .map((item) => item.key);

      if (selectedKeys.length === 0) {
        toast.warn("No items selected for deletion");
        return;
      }

      const payload = {
        key: selectedKeys,
        bookingId: bookingId
      };

      const response = await deleteSelectedImages(payload);

      setGalleryData((prev) =>
        prev.filter((item) => !selectedKeys.includes(item.key))
      );

      setSelectedItems([]);

      toast.success(response?.data?.message || "Selected images deleted");

    } catch (error) {

      console.error("Delete selected failed", error);

      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Delete selected failed"
      );

    } finally {

      setLoading(false);

    }

  };

  /* ===============================
      DOWNLOAD FULL ZIP
  =============================== */

  const buildZipFilterParams = () => {
    const params = {
      bookingId,
      photographerId: photographerId || "",
    };

    if (isEditing) {
      params.category = "";
      params.source =
        activeCategory === "Photographer Media"
          ? "photographer"
          : activeCategory === "User Media"
            ? "user"
            : "";
    }

    return params;
  };

  const getClientId = () =>
    bookingData?.client_id?._id || bookingData?.client_id || "";

  const handleDownloadZip = async () => {
    try {
      const zipFilters = buildZipFilterParams();
      await downloadGalleryZipFromCdn(zipFilters, { 
        clientId: getClientId(),
        onWaiting: () => toast.info("Preparing download from cloud storage..."),
      });
    } catch (error) {
      console.error("Zip download failed", error);
      toast.error(error.message || "ZIP download failed");
    }
  };

  useEffect(() => {
    if (!bookingId || !bookingData) return;
    if (!isEditing && !hasValidRoutePhotographer(photographerId)) return;

    const zipFilters = buildZipFilterParams();
    getGalleryZipLink(zipFilters).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingId, bookingData, photographerId, activeCategory, isEditing]);

  /* ===============================
      INITIAL LOAD
  =============================== */

  useEffect(() => {
    if (!bookingData) return;

    if (!isEditing && !hasValidRoutePhotographer(photographerId)) {
      setGalleryData([]);
      setSelectedItems([]);
      setHasMore(false);
      setPage(1);
      isFetchingRef.current = false;
      return;
    }

    setLoading(true);
    setGalleryData([]);
    setSelectedItems([]);
    setHasMore(true);
    hasMoreRef.current = true;
    pageRef.current = 1;
    prefetchActiveRef.current = false;
    prefetchStartedRef.current = false;
    loadedPagesRef.current = new Set();
    lightcasePoolSizeRef.current = 0;
    clearLightcasePool(lightcasePoolRef.current);
    isFetchingRef.current = false;
    setPage(1);
    fetchGallery(1);
  }, [bookingId, photographerId, fetchGallery, bookingData, activeCategory, isEditing]);

  useEffect(() => {
    if (page === 1) return;
    if (!isEditing && !hasValidRoutePhotographer(photographerId)) return;
    fetchGallery(page);
  }, [page, fetchGallery, photographerId, isEditing]);

  /* ===============================
      INFINITE SCROLL
  =============================== */

  useEffect(() => {

    const observer = new IntersectionObserver(
      (entries) => {

        if (
          entries[0].isIntersecting &&
          hasMore &&
          !loading &&
          !isFetchingRef.current
        ) {
          setPage((prev) => prev + 1);
        }

      },
      { threshold: 0.1 }
    );

    if (loaderRef.current) observer.observe(loaderRef.current);

    return () => observer.disconnect();

  }, [hasMore, loading]);

  /* ===============================
      LIGHTCASE GALLERY POOL (10K+)
  =============================== */

  useEffect(() => {
    const poolNode = lightcasePoolRef.current;
    return () => {
      destroyLightcaseBindings();
      clearLightcasePool(poolNode);
    };
  }, []);

  useEffect(() => {
    const container = lightcasePoolRef.current;
    if (!container) return;

    const items = visibleGalleryData;
    if (items.length < lightcasePoolSizeRef.current) {
      clearLightcasePool(container);
      lightcasePoolSizeRef.current = 0;
    }

    if (items.length === 0) return;

    const startIndex = lightcasePoolSizeRef.current;
    if (items.length <= startIndex) return;

    let cancelled = false;

    appendLightcasePoolLinks(container, items, lightcaseGroup, startIndex, bookingId).then(() => {
      if (cancelled) return;
      lightcasePoolSizeRef.current = items.length;
      bindLightcaseLinks(container);
    });

    return () => {
      cancelled = true;
    };
  }, [visibleGalleryData, lightcaseGroup, bookingId]);

  useEffect(() => {
    if (!bookingData) return;
    if (!isEditing && !hasValidRoutePhotographer(photographerId)) return;
    if (galleryData.length === 0) return;
    if (prefetchStartedRef.current) return;
    if (!hasMoreRef.current) return;

    prefetchStartedRef.current = true;
    prefetchActiveRef.current = true;
    setIsPrefetching(true);

    const prefetchRemaining = async () => {
      let nextPage = pageRef.current + 1;

      while (hasMoreRef.current) {
        const result = await fetchGallery(nextPage, { silent: true });
        if (!result?.hasMore) break;
        nextPage += 1;
      }

      prefetchActiveRef.current = false;
      setIsPrefetching(false);
    };

    prefetchRemaining();
  }, [bookingData, galleryData.length, fetchGallery, isEditing, photographerId]);

  /* ===============================
      IMAGE ACTIONS
  =============================== */

  const toggleSelect = useCallback((id) => {
    setSelectedItems((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  }, []);

  const openInLightcase = useCallback((itemId) => {
    setGalleryData((prev) => {
      const filtered = isEditing ? filterByMediaSource(prev, activeCategory) : prev;
      const item = filtered.find((entry) => entry.id === itemId);
      if (item) {
        if (!openLightcaseItem(itemId, undefined, bookingId, item) && item.url) {
          window.open(item.url, "_blank");
        }
      }
      return prev;
    });
  }, [bookingId, isEditing, activeCategory]);

  const downloadFile = useCallback(async (key) => {
    try {
      const token = getAccessToken();
      const baseUrl = (process.env.REACT_APP_PHOTOGRAPHY_ADMIN_BASE_API_URL || "").trim();

      if (!token) {
        toast.error("Authentication session expired.");
        return;
      }

      const params = new URLSearchParams({
        key: key,
        bookingId: bookingId,
        token: token
      });

      const downloadUrl = `${baseUrl}/api/admins/downloadSingleFile?${params.toString()}`;
      toast.info("File download starting...");
      window.location.href = downloadUrl;

    } catch (error) {
      console.error("Download failed", error);
      toast.error("Download failed");
    }
  }, [bookingId]);

  const downloadSelected = async () => {
    const selectedKeys = galleryData
      .filter((item) => selectedItems.includes(item.id))
      .map((item) => item.key);

    if (selectedKeys.length === 0) {
      toast.warn("Please select images to download.");
      return;
    }

    try {
      const zipFilters = buildZipFilterParams();
      await downloadGalleryZipFromCdn(
        {
          ...zipFilters,
          keys: selectedKeys,
        },
        { 
          clientId: getClientId(),
          onWaiting: () => toast.info("Preparing selected files from cloud storage..."),
        }
      );
    } catch (error) {
      console.error("Download selected failed", error);
      toast.error(error.message || "Download failed");
    }
  };

  /* ===============================
      BUILD GRID
  =============================== */

  const buildRows = () => {
    const filteredGalleryData = isEditing
      ? filterByMediaSource(galleryData, activeCategory)
      : galleryData;

    if (loading && filteredGalleryData.length === 0) {
      return (
        <div className="gallery-grid-layout">
          {Array.from({ length: 8 }).map((_, idx) => (
            <div className="gallery-box loading-skeleton" key={`initial-skeleton-${idx}`} />
          ))}
        </div>
      );
    }

    if (filteredGalleryData.length === 0) {
      return <p className="text-center w-100 py-5">No files found for {activeCategory}.</p>;
    }

    return (
      <div className="gallery-grid-layout">
        {filteredGalleryData.map((item) => {
          const itemUrl = isVideoMediaKey(item.key)
            ? getVideoPlaybackUrl(bookingId, item)
            : item.url;
          return (
            <VirtualGalleryItem 
              key={item.key} 
              isVideo={isVideoMediaKey(item.key)} 
              id={item.id}
              src={itemUrl}
            >
              <GalleryItem
                src={itemUrl}
                isVideo={isVideoMediaKey(item.key)}
                fileKey={item.key}
                id={item.id}
                isSelected={selectedItems.includes(item.id)}
                onOpenInLightcase={openInLightcase}
                onDownloadFile={downloadFile}
                onDeleteFile={deleteFile}
                onToggleSelect={toggleSelect}
              />
            </VirtualGalleryItem>
          );
        })}
      </div>
    );
  };

  /* ===============================
      COMING SOON
  =============================== */

  if (!isEditing && !hasValidRoutePhotographer(photographerId)) {
    return (
      <div className="container-fluid gallery-container">
        <div className="gallery-coming-soon">
          <FaImage />
          <h3>Deliverables coming soon</h3>
          <p>
            Photos will appear here once a photographer is assigned to this booking.
          </p>
        </div>
      </div>
    );
  }

  return (

    <div className="container-fluid gallery-container">
      <div
        ref={lightcasePoolRef}
        className="lightcase-gallery-pool"
        aria-hidden="true"
      />

      <div className="gallery-top-nav" style={{ marginBottom: "15px" }}>
        <button
          onClick={() => navigate(-1)}
          className="admin-back-btn"
        >
          ← Back
        </button>
      </div>

      <div className="gallery-header">

        <div className="gallery-left">

          {/* SELECT ALL CHECKBOX */}
          {visibleGalleryData.length > 0 && (
            <label className="select-all-label ">
              <input
                type="checkbox"
                checked={
                  selectedItems.length > 0 &&
                  selectedItems.length === visibleGalleryData.length
                }
                onChange={handleSelectAll}
              />
              Select All
            </label>
          )}
          {selectedItems.length > 0 && (
            <>
              <button
                className="download-selected-btn"
                onClick={downloadSelected}
              >
                Download Selected ({selectedItems.length})
              </button>

              <button
                className="delete-selected-btn"
                onClick={deleteSelected}
              >
                Delete Selected ({selectedItems.length})
              </button>
            </>
          )}

        </div>

        <div className="gallery-actions">

          {visibleGalleryData.length > 0 && (
            <button
              className="gallery-btn"
              onClick={handleDownloadZip}
            >
              Download Zip
            </button>
          )}

        </div>

      </div>

      {isEditing && availableCategories.length > 0 && (
        <div className="gallery-category-tabs" style={{ marginBottom: "20px", display: "flex", gap: "10px" }}>
          {availableCategories.map(cat => (
            <button
              key={cat}
              className={`category-tab ${activeCategory === cat ? "active" : ""}`}
              onClick={() => setActiveCategory(cat)}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                background: activeCategory === cat ? "var(--primary-color)" : "#fff",
                color: activeCategory === cat ? "#fff" : "#000",
                cursor: "pointer",
                fontWeight: "600"
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

{!loading && visibleGalleryData.length === 0 && (
  <div className="gallery-no-images">
    <FaImage className="gallery-no-images-icon" />
    <h3>No files in {activeCategory}</h3>
    <p>Upload or switch tabs to see other media.</p>
  </div>
)}

{buildRows()}
      {hasMore && (
        <div ref={loaderRef} style={{ textAlign: "center", padding: 20 }}>
          {(loading || isPrefetching) && (
            <div className="spinner-border" role="status" style={{ width: "2.5rem", height: "2.5rem", color: "var(--primary-color)" }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </div>
      )}

    </div>

  );
};

export default ViewImages;